import React from 'react';

const errorStyle = {
  color: '#f00',
  padding: 3
};

const FieldAlert = ({ message, style = errorStyle }) =>
  message ? (
    <div style={style}>{message}</div>
  ) : null;

export default FieldAlert;



// WEBPACK FOOTER //
// ./src/components/form/FieldAlert.js